<template>
<el-row>
  <div class="footers">
      <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="logoimg">
          <el-image
            class="logo"
            :src="require('@/assets/logo.png')"></el-image>
        </div>
        <div class="text">
              <div class="one">
                <div>
                  <router-link to="/about">
                    <p>关于我们</p>     
                    <p>公司介绍</p>
                    <p>公司荣誉</p>
                    <p>厂房展示</p>
                    <p>合作单位</p>
                    <p>发展历程</p>
                    <p>我们的优势</p>
                   </router-link>
                </div>
                <div>
                  <router-link to="/classify">
                  <p>产品分类</p>
                  <p>小学校服</p>   
                  <p>中学校服</p>
                  <p>大学校服</p>
                  <p>工装定制</p>
                </router-link>
                </div>
                <div>
                  <router-link to="/display">
                  <p>案例展示</p>
                  <p>案例展示</p>
                  </router-link>
                </div>
                <div>
                  <router-link to="/news">
                  <p>新闻动态</p>  
                  <p>公司动态</p>
                  <p>行业动态</p>
                  <p>通知公告</p>
                </router-link>
                </div>
                <div>
                  <router-link to="/serveview">
                  <p>服务流程</p>
                  <p>服务流程</p>
                  </router-link>
                </div>



              </div>
              <div class="two">
                <div>
                  <p>联系我们</p>     
                  <p>地址：河南省郑州新郑市龙湖镇柏树刘村梅山路88号</p>  
                  <p>电话：0371-55886162 18838062808</p>
                  <p>邮箱：xiwang</p>
                </div>
              </div>
              <div class="three">
                <div>
                  <el-image
                class="ma1"
                :src="require('@/assets/ma.png')"></el-image>
                <p>希望之星官方微信</p>
                </div>
                <div>
                  <el-image
                  class="ma2"
                  :src="require('@/assets/ma.png')"></el-image>
                  <p>扫码发现更多</p>
                </div>
              </div>


            </div>
      </el-col>
          <div class="foot">
          
           <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
            <p>版权所有：河南希望之星河南希望之星服饰有限公司 备案号：豫ICP备19023111号 </p> 
           </a>
            
          </div>

  </div>

     
     
</el-row>
   
</template>
<script>
export default {
  name: 'homeView2',
  props: {
    msg: String
  },
  created(){
  },
  data(){
    return{
      
    }
  }
}
</script>
<style scoped lang="less">

    .footers{
      background-image: url(../assets/footerbj.png);
      background-size: 100% 100%;
      margin-top: 50px;
        // background-color: #016F62;
        padding: 50px 60px 80px;
    }
    .logoimg{
      text-align: left;
      .logo{
        width: 152px;
        height: 61px;
      }
    }

    .text{
      display: flex;
      color: #fff;
    }
    .one{
      padding-top: 60px;
      flex-basis: 55%;
      display: flex;
      border-right: 2px solid;
      border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 20%, rgba(255, 255, 255, 0) 99%) 2 2 2 2;
      a{
      text-decoration: none;
    }
    .router-link-active {
      text-decoration: none;
    }
      div{
        flex-basis: 25%;
        p{
          text-align: left;
          font-size: 14px;
          margin-bottom: 30px;
          font-weight: 400;
          cursor: pointer;
          color: #fff;
        }
        p:nth-child(1){
          font-size: 18px;
        }
      }
    }
    .two{
      padding-left: 20px;
      padding-top: 60px;
      flex-basis: 27%;
      border-right: 2px solid;
      border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 20%, rgba(255, 255, 255, 0) 99%) 2 2 2 2;
      p{
          text-align: left;
          font-size: 14px;
          margin-bottom: 30px;
          font-weight: 400;
        }
        p:nth-child(1){
          font-size: 18px;
        }
    }
    .three{
      padding-left: 20px;
      padding-top: 60px;
      flex-basis: 18%;
      display: flex;
      justify-content: space-between;
      .ma1{
        width: 150px;
        height: 150px;
      }
      .ma2{
        width: 150px;
        height: 150px;
      }
      div{
        

      }
    }
    .foot{
      
      margin-top: 40px;
      font-size: 14px;
      padding-bottom: 6px;
      border-bottom: 1px solid #ffffff;
      
      a{
      text-decoration: none;
      color: #fff;
      }
    
    }

</style>